"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleOptions = exports.VehicleUniqueFilter = exports.VehicleFilter = exports.VehicleCategoryOptions = exports.VehicleCategoryUniqueFilter = exports.VehicleCategoryFilter = exports.VehicleFeatureCategoryOptions = exports.VehicleFeatureCategoryUniqueFilter = exports.VehicleFeatureCategoryFilter = exports.VehicleFeatureOptions = exports.VehicleFeatureUniqueFilter = exports.VehicleFeatureFilter = exports.VehicleBodyTypeOptions = exports.VehicleBodyTypeUniqueFilter = exports.VehicleBodyTypeFilter = exports.VehicleModelOptions = exports.VehicleModelUniqueFilter = exports.VehicleModelFilter = exports.VehicleMakeOptions = exports.VehicleMakeUniqueFilter = exports.VehicleMakeFilter = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const global_1 = require("../../../../global");
// -----------------------------------------------------CAR MAKE-------------------------------------------------------------------------
class VehicleMakeFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleMakeFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleMakeFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleMakeFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMakeFilter.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", String)
], VehicleMakeFilter.prototype, "metaKeywords", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleMakeFilter.prototype, "models", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleMakeFilter.prototype, "vehicles", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMakeFilter.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleMakeFilter.prototype, "promoted", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleMakeFilter.prototype, "showInFooter", void 0);
exports.VehicleMakeFilter = VehicleMakeFilter;
// This filter is used to get a unique vehicle make by unique fields
class VehicleMakeUniqueFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleMakeFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMakeUniqueFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMakeUniqueFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleMakeUniqueFilter.prototype, "name", void 0);
exports.VehicleMakeUniqueFilter = VehicleMakeUniqueFilter;
class VehicleMakeOptions extends global_1.PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleMakeOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleMakeOptions = VehicleMakeOptions;
// -----------------------------------------------------CAR MODEL-------------------------------------------------------------------------
class VehicleModelFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleModelFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleModelFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleModelFilter.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", String)
], VehicleModelFilter.prototype, "metaKeywords", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleModelFilter.prototype, "makes", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleModelFilter.prototype, "vehicles", void 0);
exports.VehicleModelFilter = VehicleModelFilter;
class VehicleModelUniqueFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelUniqueFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleModelUniqueFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleModelUniqueFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleModelUniqueFilter.prototype, "name", void 0);
exports.VehicleModelUniqueFilter = VehicleModelUniqueFilter;
class VehicleModelOptions extends global_1.PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleModelOptions = VehicleModelOptions;
// -----------------------------------------------------CAR BODY TYPE----------------------------------------------------------------
class VehicleBodyTypeFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleBodyTypeFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleBodyTypeFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleBodyTypeFilter.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleBodyTypeFilter.prototype, "vehicles", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleBodyTypeFilter.prototype, "models", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleBodyTypeFilter.prototype, "search", void 0);
exports.VehicleBodyTypeFilter = VehicleBodyTypeFilter;
class VehicleBodyTypeUniqueFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleBodyTypeUniqueFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleBodyTypeUniqueFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleBodyTypeUniqueFilter.prototype, "name", void 0);
exports.VehicleBodyTypeUniqueFilter = VehicleBodyTypeUniqueFilter;
class VehicleBodyTypeOptions extends global_1.PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleBodyTypeOptions = VehicleBodyTypeOptions;
// -----------------------------------------------------CAR FEATURE----------------------------------------------------------------
class VehicleFeatureFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFeatureFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFeatureFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureFilter.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFeatureFilter.prototype, "categories", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureFilter.prototype, "search", void 0);
exports.VehicleFeatureFilter = VehicleFeatureFilter;
class VehicleFeatureUniqueFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleModelFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureUniqueFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureUniqueFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureUniqueFilter.prototype, "name", void 0);
exports.VehicleFeatureUniqueFilter = VehicleFeatureUniqueFilter;
class VehicleFeatureOptions extends global_1.PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleFeatureOptions = VehicleFeatureOptions;
// -----------------------------------------------------CAR FEATURE CATEGORY----------------------------------------------------------------
class VehicleFeatureCategoryFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureCategoryFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFeatureCategoryFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFeatureCategoryFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureCategoryFilter.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFeatureCategoryFilter.prototype, "features", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureCategoryFilter.prototype, "search", void 0);
exports.VehicleFeatureCategoryFilter = VehicleFeatureCategoryFilter;
class VehicleFeatureCategoryUniqueFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureCategoryUniqueFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureCategoryUniqueFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureCategoryUniqueFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFeatureCategoryUniqueFilter.prototype, "name", void 0);
exports.VehicleFeatureCategoryUniqueFilter = VehicleFeatureCategoryUniqueFilter;
class VehicleFeatureCategoryOptions extends global_1.PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureCategoryOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleFeatureCategoryOptions = VehicleFeatureCategoryOptions;
// -----------------------------------------------------CAR CATEGORY----------------------------------------------------------------
class VehicleCategoryFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleCategoryFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleCategoryFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleCategoryFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleCategoryFilter.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleCategoryFilter.prototype, "search", void 0);
exports.VehicleCategoryFilter = VehicleCategoryFilter;
class VehicleCategoryUniqueFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleCategoryUniqueFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleCategoryUniqueFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleCategoryUniqueFilter.prototype, "slug", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleCategoryUniqueFilter.prototype, "name", void 0);
exports.VehicleCategoryUniqueFilter = VehicleCategoryUniqueFilter;
class VehicleCategoryOptions extends global_1.PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFeatureOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleCategoryOptions = VehicleCategoryOptions;
// -----------------------------------------------------CAR-------------------------------------------------------------------------
class VehicleFilter extends global_1.BaseFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "referenceNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "make", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "model", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "bodyType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "vin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "chassisNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "trim", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "mileage", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "fuelType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "color", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "engineCapacity", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "numberOfCylinders", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "cylinderCapacity", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "doors", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "seats", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "keys", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "wheelsType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "airbags", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "transmission", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "driveType", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "emissions", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "year", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "price", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    (0, class_transformer_1.Type)(() => global_1.NumberRange),
    __metadata("design:type", global_1.NumberRange)
], VehicleFilter.prototype, "emi", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "status", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleFilter.prototype, "includeReserved", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleFilter.prototype, "includeUnpublished", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleFilter.prototype, "includeSelfReserved", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleFilter.prototype, "includeSold", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleFilter.prototype, "includeDraft", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ each: true }),
    __metadata("design:type", Object)
], VehicleFilter.prototype, "features", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFilter.prototype, "search", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFilter.prototype, "warranty", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleFilter.prototype, "compareCarId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], VehicleFilter.prototype, "specialDeals", void 0);
exports.VehicleFilter = VehicleFilter;
class VehicleUniqueFilter {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleUniqueFilter, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleUniqueFilter.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleUniqueFilter.prototype, "referenceNumber", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleUniqueFilter.prototype, "refId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleUniqueFilter.prototype, "vin", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], VehicleUniqueFilter.prototype, "chassisNumber", void 0);
exports.VehicleUniqueFilter = VehicleUniqueFilter;
class VehicleOptions extends global_1.PaginationOptions {
    validate() {
        const errors = (0, class_validator_1.validateSync)(this);
        return errors.map((error) => { var _a; return Object.values((_a = error.constraints) !== null && _a !== void 0 ? _a : {}); }).flat();
    }
    static fromPlain(plain) {
        return (0, class_transformer_1.plainToClass)(VehicleOptions, plain);
    }
    static toPlain(entity) {
        return (0, class_transformer_1.instanceToPlain)(entity);
    }
}
exports.VehicleOptions = VehicleOptions;
